import type { RouteLocationNormalizedLoadedGeneric, createRouter } from 'vue-router'

export const resolveSettingsRoutePath = (
  router: ReturnType<typeof createRouter>,
  route: RouteLocationNormalizedLoadedGeneric,
  tab: string,
): string => router.resolve({ ...route, query: { ...route.query, settings: tab } }).fullPath
